export default __webpack_public_path__ + "static/media/shuttle.d568286e.svg";